// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.82.1-next',
  revision: '9c04bc5c',
  branch: 'next',
  date: 'Tue, 02 Dec 2025 15:31:14 GMT'
};